import React, { useEffect, useState } from "react";
import "../css/Spinning.css";
import axios from 'axios';

function WellnessCheckInForm() {
    const debugging_without_calling_API = false;

    const convertTo24HourFormat = (time) => {
        const [hours, minutesPart] = time.split(":");
        const minutes = minutesPart.slice(0, 2);
        const period = minutesPart.slice(2).trim().toUpperCase(); // 提取 AM 或 PM

        let hours24 = parseInt(hours, 10);
        if (period === "PM" && hours24 !== 12) {
            hours24 += 12; // 下午加 12，但 12 PM 不变
        } else if (period === "AM" && hours24 === 12) {
            hours24 = 0; // 12 AM 为午夜
        }

        return `${String(hours24).padStart(2, "0")}:${minutes}`; // 返回 24 小时制时间
    };

    const getISO8601WithTimezone = (date, time) => {
        const [hours, minutes] = time.split(":");
        const updatedDate = new Date(date);
        updatedDate.setHours(parseInt(hours, 10));
        updatedDate.setMinutes(parseInt(minutes, 10));
        updatedDate.setSeconds(0);
        return updatedDate.toISOString();
    };

    const getCurrentDateTime = () => {
        const now = new Date();

        // 手動調整到 GMT+8
        const gmt8Offset = 8 * 60 * 60 * 1000; // 8 小時的毫秒數
        const gmt8Date = new Date(now.getTime() + gmt8Offset + 120 * 1000);

        // 提取日期和時間部分
        const date = gmt8Date.toISOString().split("T")[0]; // 格式化為 YYYY-MM-DD
        const time = gmt8Date.toISOString().split("T")[1].slice(0, 5); // 格式化為 HH:mm
        return { date, time };
    };


    const { date: currentDate, time: currentTime } = getCurrentDateTime();

    const [formData, setFormData] = useState({
        email: "",
        gender: "",
        nationality: "",
        birthday: "",
        name: "",
        sleepTime: "22:00",
        wakeUpTime: "06:00",
        checkInDate: currentDate,
        checkOutDate: "",
        checkOutTime: "",
        sleepProblem: "",
        sleepSolution: "",
        useAroma: "",
        travelWith: "",
        hotelName: "",
        roomNumber: "",
        mobileNumber: "",
        // handleBy: "", // 新增字段
        // otherHandleBy: "", // 當選擇 Others 時存儲輸入框的值
        remarks: "",
        wellBeing: "",
        aromaStrength: "",
        safetyConcerns: "",
        wellnessPriority: "",
        visitReason: "",

        form_created_time: new Date().toISOString(), // 新增字段，設置為當前時間
    });

    const [isChecked, setIsChecked] = useState(false); // State to track checkbox
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showSuccessPage, setShowSuccessPage] = useState(false); // 控制是否顯示成功頁面
    const [showLoadingPage, setShowLoadingPage] = useState(false); // 加載頁面狀態
    const [roomNumber, setRoomNumber] = useState(""); // 存儲用戶輸入的房間號碼
    const [inputRoomNumber, setInputRoomNumber] = useState("");
    const [serialNumber, setSerialNumber] = useState(null); // 儲存對應的 Serial Number

    const handleRoomConfirm = (roomNumber, serialNumber) => {
        setRoomNumber(roomNumber); // 保存房間號
        setSerialNumber(serialNumber); // Save serial number
        setShowSuccessPage(false); // 隱藏 Success Page
        setShowLoadingPage(true); // 顯示 Loading Page
    };

    const handleLoadingComplete = () => {
        setShowLoadingPage(false); // 隱藏 Loading Page（後續操作可在此添加）
    };

    const buttonStyle = {
        padding: "10px 20px",
        border: "none",
        borderRadius: "5px",
        color: "white",
        fontSize: "16px",
        cursor: "pointer",
        marginRight: "10px",
        marginTop: "10px",
        marginBottom: "10px",
        textDecoration: "none", // 移除链接的默认下划线
        display: "inline-block", // 使链接看起来像按钮
    };

    const whatsappStyle = {
        ...buttonStyle,
        backgroundColor: "#25D366", // WhatsApp 绿色
    };

    const messengerStyle = {
        ...buttonStyle,
        backgroundColor: "#0078FF", // Messenger 蓝色
    };

    const validateForm = () => {
        const newErrors = {};

        // 必填字段校驗
        if (!formData.email.trim()) {
            newErrors.email = "Please provide your email address.";
        }

        if (!formData.name.trim()) {
            newErrors.name = "Please provide your name.";
        }

        if (!formData.mobileNumber.trim()) {
            newErrors.mobileNumber = "Please provide your phone number.";
        }

        if (!formData.checkInDate.trim()) {
            newErrors.checkInDate = "Please provide the date of check-in.";
        }

        if (!formData.checkOutDate.trim()) {
            newErrors.checkOutDate = "Please provide the date of check-out.";
        }

        if (!formData.wakeUpTime.trim()) {
            newErrors.wakeUpTime = "Please provide your time of wake up.";
        }

        if (!formData.sleepTime.trim()) {
            newErrors.sleepTime = "Please provide your time of getting into the bed.";
        }

        if (!formData.nationality.trim()) {
            newErrors.nationality = "Please provide your nationality.";
        }

        if (!formData.birthday.trim()) {
            newErrors.birthday = "Please provide your birthday.";
        }

        if (!formData.gender.trim()) {
            newErrors.gender = "Please provide your gender.";
        }

        if (!formData.travelWith.trim()) {
            newErrors.travelWith = "Please provide your choice.";
        }

        if (!formData.wellBeing.trim()) {
            newErrors.wellBeing = "Please provide your choice.";
        }

        if (!formData.sleepProblem.trim()) {
            newErrors.sleepProblem = "Please provide your choice.";
        }

        if (!formData.aromaStrength.trim()) {
            newErrors.aromaStrength = "Please provide your choice.";
        }

        if (!formData.safetyConcerns.trim()) {
            newErrors.safetyConcerns = "Please provide your choice.";
        }

        if (!formData.wellnessPriority.trim()) {
            newErrors.wellnessPriority = "Please provide your choice.";
        }

        if (!formData.visitReason.trim()) {
            newErrors.visitReason = "Please provide your choice.";
        }

        if (!formData.useAroma.trim()) {
            newErrors.useAroma = "Please provide your choice.";
        }

        setErrors(newErrors);

        // 如果沒有錯誤，返回 true，否則返回 false
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "nationality") {
            if (value === "Others") {
                // 保持 select 值為 "Others"，並顯示輸入框
                setFormData((prev) => ({ ...prev, nationality: "Others" }));
            } else {
                // 更新為選擇的值，隱藏輸入框
                setFormData((prev) => ({ ...prev, nationality: value }));
            }
        } else {
            // 通用處理其他輸入框
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!debugging_without_calling_API) {
            // 校驗表單
            if (!validateForm()) {
                return; // 如果校驗失敗，阻止提交
            }


            if (!isChecked) {
                alert("You must agree to the terms and conditions before proceeding.");
                return;
            }
        }

        setIsSubmitting(true);

        // 如果 email 為空，生成帶有 UTC 時間戳的 email
        const email = formData.email.trim() === ""
            ? `empty_email_${new Date().toISOString()}`
            : formData.email;

        // 如果選擇了 Others，使用 otherHandleBy 的值
        const dataToSubmit = {
            ...formData,
            email, // 使用處理後的 email
            nationality:
                formData.nationality === "Others"
                    ? formData.otherNationality
                    : formData.nationality,
        };

        if (!debugging_without_calling_API) {
            try {
                const response = await fetch(
                    "https://hocyc82op1.execute-api.ap-southeast-1.amazonaws.com/checkin",
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization:
                                "Bearer RaXc*lq3j5=1w<$rD^C+}VGvZVi]=dWN}P}(^~XK;h6%O@D;KkqKm~uU>+f,dqY",
                        },
                        body: JSON.stringify(dataToSubmit),
                    }
                );

                if (response.ok) {

                    setShowSuccessPage(true); // 顯示成功頁面
                    setFormData(dataToSubmit); // 更新 formData 狀態
                } else {
                    alert("Failed to submit the form. Please try again.");
                }
            } catch (error) {
                console.error("Error submitting the form:", error);
                alert("An error occurred. Please try again.");
            } finally {
                setIsSubmitting(false);
            }
        } else if (debugging_without_calling_API) {
            setFormData(dataToSubmit); // 更新 formData 狀態
            setShowSuccessPage(true); // 顯示成功頁面
            setIsSubmitting(false);
        }


    };

    const updateRoomNumber = async (email, roomNumber) => {

        if (!debugging_without_calling_API) {
            try {
                const response = await fetch(
                    "https://hocyc82op1.execute-api.ap-southeast-1.amazonaws.com/checkin/edit",
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization:
                                "Bearer RaXc*lq3j5=1w<$rD^C+}VGvZVi]=dWN}P}(^~XK;h6%O@D;KkqKm~uU>+f,dqY",
                        },
                        body: JSON.stringify({
                            email, // 使用 email 作為 Partition Key
                            roomNumber, // 要更新的房間號碼
                        }),
                    }
                );
                console.log(response);
                if (response.ok) {
                    const result = await response.json();
                    // alert("Room number updated successfully!");
                    // setFormData(initialFormData);
                    setShowSuccessPage(false); // 關閉成功頁面
                    setShowLoadingPage(true);
                } else {
                    const errorData = await response.json();
                    alert(`Failed to update room number: ${errorData.message}`);
                }
            } catch (error) {
                console.error("Error updating room number:", error);
                alert("Failed to update room number.");
            }
        } else if (debugging_without_calling_API) {
            // alert("Room number updated successfully!");
            // setFormData(initialFormData);
            setShowSuccessPage(false); // 關閉成功頁面
            setShowLoadingPage(true);
        }

    };

    const SuccessPage = ({ onConfirm, onCancel }) => {
        const [inputRoomNumber, setInputRoomNumber] = useState("");
        const [loading, setLoading] = useState(false); // 加載狀態

        const fetchGoogleSheetData = async () => {
            try {
                const response = await axios.get(
                    `https://docs.google.com/spreadsheets/d/1fQwkxil-foADfQFMWw9WNi_ms1lfcH1xIA5Omcnn5_M/gviz/tq?tqx=out:json`
                );
                const text = response.data;
                const json = JSON.parse(text.substr(47).slice(0, -2)); // 清理返回的 JSON 數據
                const rows = json.table.rows.map((row) =>
                    row.c.map((cell) => (cell ? cell.v : ""))
                );

                // 构建 roomNumber 到 serialNumber 的映射
                const roomToSerialMapping = rows.reduce((acc, row) => {
                    const serialNumber = row[0]; // 假設 Serial Number 在第 0 列
                    const roomNumber = row[2]; // 假設 Room Number 在第 2 列
                    if (serialNumber && roomNumber) {
                        acc[roomNumber] = serialNumber; // 將 Room Number 映射到 Serial Number
                    }
                    return acc;
                }, {});

                return roomToSerialMapping; // 返回映射
            } catch (err) {
                console.error("Failed to fetch Google Sheet data:", err.message);
                return {};
            }
        };

        const handleConfirm = async () => {
            if (inputRoomNumber) {
                setLoading(true);
                try {
                    // 獲取 Google Sheet 數據
                    const roomToSerialMapping = await fetchGoogleSheetData();
                    const serial = roomToSerialMapping[inputRoomNumber]; // 查找對應的 Serial Number

                    if (serial) {
                        setSerialNumber(serial); // 保存 Serial Number
                        const confirmed = window.confirm(
                            `Room ${inputRoomNumber} is ready for setup. Confirm? (Ref.: SN-${serial})`
                        );
                        if (confirmed) {
                            onConfirm(inputRoomNumber, serial); // 傳遞 Room Number 和 Serial Number
                        }
                    } else {
                        alert(`Room ${inputRoomNumber} is not ready for setup, please enter with the correct room number.`);
                    }
                } catch (error) {
                    console.error("Error fetching data:", error);
                    alert("Failed to fetch data. Please try again.");
                } finally {
                    setLoading(false);
                }
            } else {
                alert("Please enter a valid room number.");
            }
        };

        return (
            <div style={styles.successPage}>
                <h1 style={{ ...styles.heading, color: "green" }}>Thank you!</h1>
                <p style={styles.text}>
                    Dear Guest, your Check-In process is almost complete. Please enter your room number, and we will activate the Aromatherapy service for you!
                </p>
                <input
                    type="text"
                    value={inputRoomNumber}
                    onChange={(e) => setInputRoomNumber(e.target.value)}
                    style={styles.input}
                    placeholder="Room Number"
                />
                <button
                    onClick={handleConfirm}
                    disabled={loading || !inputRoomNumber.trim()} // 按鈕禁用條件
                    style={{
                        ...styles.confirmButton,
                        ...(loading || !inputRoomNumber.trim()
                            ? styles.disabledButton // 添加灰色樣式
                            : {}),
                    }}
                >
                    {loading ? "Loading..." : "Confirm"}
                </button>
                <button onClick={onCancel} style={styles.cancelButton}>
                    Cancel
                </button>
            </div>
        );
    };

    const LoadingPage = ({ roomNumber, serialNumber, formData, onLoadingComplete }) => {
        const [isLoading, setIsLoading] = useState(true); // 控制加載動畫
        const [apiResponse, setApiResponse] = useState(null); // 儲存 API 回應數據
        const [isResultsVisible, setIsResultsVisible] = useState(false); // 控制是否顯示結果頁面
        const [schedules, setSchedules] = useState([]); // 保存返回的 schedules
        const [showModal, setShowModal] = useState(false); // 控制是否显示 modal
        const [isAutoScheduling, setIsAutoScheduling] = useState(false); // 控制自动排程按钮状态


        // 組建新的 formData
        const buildApiFormData = () => {
            console.log(formData.checkInDate);
            console.log(new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }));

            let api_send_time = getISO8601WithTimezone(
                formData.checkInDate, // 使用 formData 中的 checkInDate
                new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })
            );


            // 转换为 Date 对象并加 2 分钟
            const date = new Date(api_send_time); // 将结果转换为 Date 对象
            date.setMinutes(date.getMinutes() + 2); // 增加 2 分钟
            api_send_time = date.toISOString(); // 转换回 ISO 8601 格式

            const apiFormData = {
                device_sn: serialNumber, // 从 props 获取 serialNumber
                customer_id: formData?.mobileNumber || "", // 使用可选链访问数据，并提供默认值
                api_send_time: api_send_time,
                checkin_date: formData?.checkInDate || "",
                checkout_date: formData?.checkOutDate || "",
                wakeup_time: formData?.wakeUpTime || "",
                sleep_time: formData?.sleepTime || "",
                morning_aroma: "Metal",
                morning_intensity_level: (formData?.aromaStrength || 0) * 20,
                afternoon_aroma: "Fire",
                afternoon_intensity_level: (formData?.aromaStrength || 0) * 20,
                evening_aroma: "Wood",
                evening_intensity_level: (formData?.aromaStrength || 0) * 20,
                late_night_aroma: "Earth",
                late_night_intensity_level: (formData?.aromaStrength || 0) * 20,
                isConcern: formData?.safetyConcerns === "Yes" ? 1 : 0, // 将布尔值转换为数字
            };
            console.log("构建的 API 请求数据:", apiFormData);
            return apiFormData;
        };

        useEffect(() => {
            handleApiRequest(); // 调用 API 请求
        }, []); // 只在组件挂载时调用一次

        // 发起 API 请求
        const handleApiRequest = async () => {
            setIsLoading(true); // 开始加载

            const requestData = buildApiFormData(); // 构建 API 请求数据

            try {
                const response = await fetch(
                    "https://1700v3lt3e.execute-api.ap-east-1.amazonaws.com/kl-admin-autoscheduling/v2",
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "kl-project-admin",
                        },
                        body: JSON.stringify(requestData),
                    }
                );

                if (response.ok) {
                    const responseData = await response.json();
                    console.log("API 响应:", responseData);

                    // 如果返回的数据包含 schedules，则保存并调用自动排程
                    if (responseData.schedules && responseData.schedules.length > 0) {
                        setSchedules(responseData.schedules); // 保存 schedules
                        await handleAutoSchedule(responseData.schedules); // 自动执行 handleAutoSchedule
                    }
                    setApiResponse(responseData); // 保存 API 响应数据
                    setIsResultsVisible(true); // 显示结果页面
                } else {
                    console.error("API 请求失败:", response.statusText);
                    alert("API 请求失败: " + response.statusText);
                }
            } catch (error) {
                console.error("API 请求错误:", error);
                alert("API 请求失败！");
            } finally {
                setIsLoading(false); // 停止加载动画
            }
        };

        // 自动排程功能
        const handleAutoSchedule = async (schedulesData) => {
            setIsAutoScheduling(true); // 设置 Auto-Schedule 状态为禁用

            try {
                // 确保表单中的 serialNumber 存在
                if (!serialNumber) {
                    alert("Device Sn is required to auto-schedule!");
                    setIsAutoScheduling(false); // 重置按钮状态
                    return;
                }

                // 遍历每个 schedule，逐一发送 API 请求
                for (const schedule of schedulesData) {
                    const response = await fetch(
                        "https://7dqq5knnv0.execute-api.ap-southeast-1.amazonaws.com/add-schedule",
                        {
                            method: "PUT",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                                serial_number: serialNumber, // 使用 props 中的 serialNumber
                                timezone: "+08:00", // 假设的时区
                                start_time: schedule.start_time,
                                end_time: schedule.end_time,
                                aroma_scent: schedule.scheduled_parameters.element,
                                aroma_intensity: schedule.scheduled_parameters.intensity,
                            }),
                        }
                    );

                    if (!response.ok) {
                        console.log(`Failed to add schedule: ${response.status}`);
                        // throw new Error(`Failed to add schedule: ${response.status}`);
                    }
                }

                console.log("All schedules added successfully!");

            } catch (error) {
                console.error("Error during auto-schedule:", error);
                alert("Failed to auto-schedule. Please try again.");
            } finally {
                setIsAutoScheduling(false); // 重置状态
            }
        };

        // 动态生成 WhatsApp 链接
        const whatsappLink = `https://wa.me/85293789122?text=Room:%20${inputRoomNumber}%0A%0AWonderful%20choice!%20Your%20personal%20aroma%20journey%20is%20now%20set.%20You%20can%20view%20and%20adjust%20your%20schedule%20and%20intensity%20preferences%20anytime%20from%20the%20Personal%20Aroma%20Journey%20Schedule%20page%20in%20your%20room%20interface.%0A%0AThis%20is%20your%20personal%20aroma%20journey:%0A%0AAfternoon%20:%20Wood%20Element%0AEvening:%20Earth%20Element%0ASleep%20:%20Earth%20Element%0AMorning%20:%20Wood%20Element%0A%0AIf%20you%20need%20assistance%20or%20wish%20to%20make%20changes%20to%20your%20preferences,%20feel%20free%20to%20reach%20out%20through%20this%20chat%20anytime.%20Enjoy%20your%20stay%20and%20your%20Aromapod%20Pro%20experience!%20%F0%9F%98%8A%0A%0A`;
        const messagerLink = `https://m.me/557348704109942?text=Room:%20${inputRoomNumber}%0A%0AWonderful%20choice!%20Your%20personal%20aroma%20journey%20is%20now%20set.%20You%20can%20view%20and%20adjust%20your%20schedule%20and%20intensity%20preferences%20anytime%20from%20the%20Personal%20Aroma%20Journey%20Schedule%20page%20in%20your%20room%20interface.%0A%0AThis%20is%20your%20personal%20aroma%20journey:%0A%0AAfternoon%20:%20Wood%20Element%0AEvening:%20Earth%20Element%0ASleep%20:%20Earth%20Element%0AMorning%20:%20Wood%20Element%0A%0AIf%20you%20need%20assistance%20or%20wish%20to%20make%20changes%20to%20your%20preferences,%20feel%20free%20to%20reach%20out%20through%20this%20chat%20anytime.%20Enjoy%20your%20stay%20and%20your%20Aromapod%20Pro%20experience!%20%F0%9F%98%8A%0A%0A`;


        return (
            <div style={styles.container}>
                <div style={styles.card}>
                    {isLoading ? (
                        <>
                            <h1 style={styles.heading}>Loading...</h1>
                            <div style={styles.loadingSpinner}></div>
                            <p style={styles.text}>We are setting up personalized experience for you.</p>
                            <p style={styles.text}>Please do not leave this site and wait for moments.</p>
                        </>
                    ) : isResultsVisible ? (
                        <div>
                            <h1>One last step to upgrade your room!</h1>
                            <p>Confirm Via WhatsApp or Confirm Via Messenger</p>
                            {/* WhatsApp 和 Messenger 链接 */}
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center"}}>
                                <a
                                    href={whatsappLink}
                                    style={whatsappStyle}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    WhatsApp
                                </a>

                                <a
                                    href={messagerLink}
                                    style={messengerStyle}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Messenger
                                </a>
                            </div>
                        </div>
                    ) : (
                        <h1>An error occurred. Please try again.</h1>
                    )}
                </div>
            </div>
        );
    };

    return (


        <div style={styles.container}>
            {showLoadingPage ? (
                <LoadingPage
                    roomNumber={roomNumber} // 傳遞房間號
                    serialNumber={serialNumber} // 傳遞對應的 Serial Number
                    formData={formData} // 傳遞整個 formData
                    inputRoomNumber={inputRoomNumber} // 傳遞房間號
                    onLoadingComplete={() => setShowLoadingPage(false)} // 加載完成後隱藏
                />
            ) : showSuccessPage ? (
                <SuccessPage
                onConfirm={(roomNumber, serialNumber) => {
                    setInputRoomNumber(roomNumber); // 存儲房間號
                    setSerialNumber(serialNumber); // 存儲序列號
                    updateRoomNumber(formData.email, roomNumber, serialNumber); // 執行更新操作
                }}
                    onCancel={() => setShowSuccessPage(false)}
                />
            ) : (
                <form onSubmit={handleSubmit} style={styles.card}>
                    <h1 style={styles.heading}>Hotel Guest Check-In Form</h1>

                    {/* Email */}
                    <label style={styles.label}>Email</label>
                    <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        style={{
                            ...styles.input, // 基礎樣式
                            ...(errors.email ? styles.inputError : {}), // 錯誤樣式
                        }}
                    />
                    {errors.email && <p style={styles.errorMessage}>{errors.email}</p>} {/* 錯誤提示 */}

                    {/* Handle by */}
                    {/* <label style={styles.label}>Handle by</label>
                <select
                    name="handleBy"
                    value={formData.handleBy}
                    onChange={handleChange}
                    style={styles.input}
                >
                    <option value="">Select Handler</option>
                    <option value="Jennefer Dolloso">Jennefer Dolloso</option>
                    <option value="Kat Lai">Kat Lai</option>
                    <option value="Alfie Barriga">Alfie Barriga</option>
                    <option value="Others">Others</option>
                </select> */}

                    {/* 顯示輸入框當選擇 Others 時 */}
                    {/* {formData.handleBy === "Others" && (
                    <>
                        <label style={styles.label}>If Others, please specify</label>
                        <input
                            type="text"
                            name="otherHandleBy"
                            value={formData.otherHandleBy}
                            onChange={(e) =>
                                setFormData((prev) => ({ ...prev, otherHandleBy: e.target.value }))
                            }
                            style={styles.input}
                            placeholder="Enter the handler's name"
                        />
                    </>
                )} */}

                    {/* Hotel Name */}
                    <label style={styles.label}>Hotel Name</label>
                    <input
                        type="text"
                        name="hotelName"
                        value={formData.hotelName}
                        onChange={handleChange}
                        style={{
                            ...styles.input,
                            ...(errors.hotelName ? styles.inputError : {}),
                        }}
                        placeholder="Enter your hotel name"
                    />
                    {errors.hotelName && <p style={styles.errorMessage}>{errors.hotelName}</p>}

                    {/* Room Number */}
                    {/* <label style={styles.label}>Room Number</label>
        <input
          type="text"
          name="roomNumber"
          value={formData.roomNumber}
          onChange={handleChange}
          style={styles.input}
          placeholder="Enter your room number"
        /> */}




                    {/* Gender */}
                    <label style={styles.label}>Gender</label>
                    <div style={styles.radioGroup}>
                        <label style={styles.radioLabel}>
                            <input
                                type="radio"
                                name="gender"
                                value="Male"
                                checked={formData.gender === "Male"}
                                onChange={handleChange}
                                style={styles.radioInput}
                            />
                            Male
                        </label>
                        <label style={styles.radioLabel}>
                            <input
                                type="radio"
                                name="gender"
                                value="Female"
                                checked={formData.gender === "Female"}
                                onChange={handleChange}
                                style={styles.radioInput}
                            />
                            Female
                        </label>
                    </div>
                    {errors.gender && <p style={styles.errorMessage}>{errors.gender}</p>}

                    {/* Nationality */}
                    <label style={styles.label}>Nationality</label>
                    <select
                        name="nationality"
                        value={formData.nationality === "Others" ? "Others" : formData.nationality}
                        onChange={(e) => {
                            const selectedValue = e.target.value;
                            const [country, code] = selectedValue.split("|");
                            setFormData((prev) => ({
                                ...prev,
                                nationality: selectedValue,
                                mobileNumber: code || "",
                            }));
                        }}
                        style={{
                            ...styles.input, // 基础样式
                            ...(errors.nationality ? styles.inputError : {}), // 错误样式
                        }}
                    >
                        <option value="">Select Nationality</option>
                        <option value="American|+1">American (+1)</option>
                        <option value="Australian|+61">Australian (+61)</option>
                        <option value="Brazilian|+55">Brazilian (+55)</option>
                        <option value="Canadian|+1">Canadian (+1)</option>
                        <option value="Chinese|+86">Chinese (+86)</option>
                        <option value="Filipino|+63">Filipino (+63)</option>
                        <option value="Hong Kong|+852">Hong Kong (+852)</option>
                        <option value="Indian|+91">Indian (+91)</option>
                        <option value="Japanese|+81">Japanese (+81)</option>
                        <option value="Korean|+82">Korean (+82)</option>
                        <option value="Malaysian|+60">Malaysian (+60)</option>
                        <option value="Singaporean|+65">Singaporean (+65)</option>
                        <option value="Thai|+66">Thai (+66)</option>
                        <option value="Vietnamese|+84">Vietnamese (+84)</option>
                        <option value="Others">Others</option>
                    </select>
                    {errors.nationality && <p style={styles.errorMessage}>{errors.nationality}</p>}

                    {/* 顯示輸入框 */}
                    {formData.nationality === "Others" && (
                        <>
                            <label style={styles.label}>If Others, please specify</label>
                            <input
                                type="text"
                                name="otherNationality"
                                value={formData.otherNationality || ""}
                                onChange={(e) =>
                                    setFormData((prev) => ({ ...prev, otherNationality: e.target.value }))
                                }
                                style={styles.input}
                                placeholder="Enter your nationality"
                            />
                        </>
                    )}

                    {/* Mobile Number */}
                    <label style={styles.label}>Mobile Number</label>
                    <input
                        type="tel"
                        name="mobileNumber"
                        value={formData.mobileNumber}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (/^\+?\d*$/.test(value)) {
                                setFormData((prev) => ({ ...prev, mobileNumber: value }));
                            }
                        }}
                        style={{
                            ...styles.input,
                            ...(errors.mobileNumber ? styles.inputError : {}),
                        }}
                        placeholder="e.g., +85212345678"
                    />
                    {errors.mobileNumber && <p style={styles.errorMessage}>{errors.mobileNumber}</p>}

                    {/* Birthday */}
                    <label style={styles.label}>Birthday (YYYYMMDD)</label>
                    <input
                        type="text"
                        name="birthday"
                        value={formData.birthday}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d{0,8}$/.test(value)) {
                                setFormData((prev) => ({ ...prev, birthday: value }));
                            }
                        }}
                        style={{
                            ...styles.input,
                            ...(errors.birthday ? styles.inputError : {}),
                        }}
                        placeholder="Enter your birthday (YYYYMMDD)"
                    />
                    {errors.birthday && <p style={styles.errorMessage}>{errors.birthday}</p>}

                    {/* Name */}
                    <label style={styles.label}>Name</label>
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        style={{
                            ...styles.input,
                            ...(errors.name ? styles.inputError : {}),
                        }}
                    />
                    {errors.name && <p style={styles.errorMessage}>{errors.name}</p>}

                    {/* Sleep Time */}
                    {/* <label style={styles.label}>Sleep Time</label>
                    <input
                        type="time"
                        name="sleepTime"
                        value={formData.sleepTime}
                        onChange={handleChange}
                        style={{
                            ...styles.input,
                            ...(errors.sleepTime ? styles.inputError : {}),
                        }}
                    /> */}
                    {/* {errors.sleepTime && <p style={styles.errorMessage}>{errors.sleepTime}</p>} */}

                    {/* Wake Up Time */}
                    {/* <label style={styles.label}>Wake Up Time</label>
                    <input
                        type="time"
                        name="wakeUpTime"
                        value={formData.wakeUpTime}
                        onChange={handleChange}
                        style={{
                            ...styles.input,
                            ...(errors.wakeUpTime ? styles.inputError : {}),
                        }}
                    />
                    {errors.wakeUpTime && <p style={styles.errorMessage}>{errors.wakeUpTime}</p>} */}

                    <label style={styles.label}>Sleep Time</label>
                    <div style={{ display: "flex", gap: "10px", marginBottom: "25px" }}>
                        <select
                            name="sleepHour"
                            value={formData.sleepTime.split(":")[0]} // 确保值为字符串
                            onChange={(e) => {
                                const hour = e.target.value; // 保持字符串格式
                                const minute = formData.sleepTime.split(":")[1] || "00";
                                const updatedTime = `${hour}:${minute}`;
                                setFormData((prev) => ({ ...prev, sleepTime: updatedTime }));
                            }}
                            style={styles.select}
                        >
                            {Array.from({ length: 24 }, (_, i) => {
                                const hour = i.toString().padStart(2, "0"); // 确保值为字符串且前导零
                                return (
                                    <option key={hour} value={hour}>
                                        {hour}
                                    </option>
                                );
                            })}
                        </select>
                        <select
                            name="sleepMinute"
                            value={formData.sleepTime.split(":")[1]} // 确保值为字符串
                            onChange={(e) => {
                                const hour = formData.sleepTime.split(":")[0] || "00";
                                const minute = e.target.value; // 保持字符串格式
                                const updatedTime = `${hour}:${minute}`;
                                setFormData((prev) => ({ ...prev, sleepTime: updatedTime }));
                            }}
                            style={styles.select}
                        >
                            {Array.from({ length: 60 }, (_, i) => {
                                const minute = i.toString().padStart(2, "0"); // 确保值为字符串且前导零
                                return (
                                    <option key={minute} value={minute}>
                                        {minute}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                    {errors.sleepTime && <p style={styles.errorMessage}>{errors.sleepTime}</p>}

                    <label style={styles.label}>Wake Up Time</label>
                    <div style={{ display: "flex", gap: "10px", marginBottom: "25px" }}>
                        <select
                            name="wakeUpHour"
                            value={formData.wakeUpTime.split(":")[0] || "00"} // 确保值为字符串，默认值为 "00"
                            onChange={(e) => {
                                const hour = e.target.value; // 保持字符串格式
                                const minute = formData.wakeUpTime.split(":")[1] || "00";
                                const updatedTime = `${hour}:${minute}`;
                                console.log("Selected Wake Up Hour:", hour); // 调试日志
                                setFormData((prev) => ({ ...prev, wakeUpTime: updatedTime }));
                            }}
                            style={styles.select}
                        >
                            {Array.from({ length: 24 }, (_, i) => {
                                const hour = i.toString().padStart(2, "0"); // 确保值为两位字符串
                                return (
                                    <option key={hour} value={hour}>
                                        {hour}
                                    </option>
                                );
                            })}
                        </select>
                        <select
                            name="wakeUpMinute"
                            value={formData.wakeUpTime.split(":")[1] || "00"} // 确保值为字符串，默认值为 "00"
                            onChange={(e) => {
                                const hour = formData.wakeUpTime.split(":")[0] || "00";
                                const minute = e.target.value; // 保持字符串格式
                                const updatedTime = `${hour}:${minute}`;
                                console.log("Selected Wake Up Minute:", minute); // 调试日志
                                setFormData((prev) => ({ ...prev, wakeUpTime: updatedTime }));
                            }}
                            style={styles.select}
                        >
                            {Array.from({ length: 60 }, (_, i) => {
                                const minute = i.toString().padStart(2, "0"); // 确保值为两位字符串
                                return (
                                    <option key={minute} value={minute}>
                                        {minute}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                    {errors.wakeUpTime && <p style={styles.errorMessage}>{errors.wakeUpTime}</p>}

                    {/* Check-In Date */}
                    <label style={styles.label}>Check-In Date</label>
                    <input
                        type="date"
                        name="checkInDate"
                        value={formData.checkInDate}
                        onChange={handleChange}
                        style={{
                            ...styles.input,
                            ...(errors.checkInDate ? styles.inputError : {}),
                        }}
                    />
                    {errors.checkInDate && <p style={styles.errorMessage}>{errors.checkInDate}</p>}

                    {/* Check-Out Date */}
                    <label style={styles.label}>Check-Out Date</label>
                    <input
                        type="date"
                        name="checkOutDate"
                        value={formData.checkOutDate}
                        onChange={handleChange}
                        style={{
                            ...styles.input,
                            ...(errors.checkOutDate ? styles.inputError : {}),
                        }}
                    />
                    {errors.checkOutDate && <p style={styles.errorMessage}>{errors.checkOutDate}</p>}

                    {/* Sleep Problem */}
                    <label style={styles.label}>Any Sleep Problem?</label>
                    <div style={styles.radioGroup}>
                        <label style={styles.radioLabel}>
                            <input
                                type="radio"
                                name="sleepProblem"
                                value="Yes"
                                checked={formData.sleepProblem === "Yes"}
                                onChange={handleChange}
                                style={styles.radioInput}
                            />
                            Yes
                        </label>
                        <label style={styles.radioLabel}>
                            <input
                                type="radio"
                                name="sleepProblem"
                                value="No"
                                checked={formData.sleepProblem === "No"}
                                onChange={handleChange}
                                style={styles.radioInput}
                            />
                            No
                        </label>
                    </div>
                    {errors.sleepProblem && <p style={styles.errorMessage}>{errors.sleepProblem}</p>}

                    {/* Sleep Solution */}
                    {formData.sleepProblem === "Yes" && (
                        <>
                            <label style={styles.label}>If yes, any solutions?</label>
                            <input
                                type="text"
                                name="sleepSolution"
                                value={formData.sleepSolution}
                                onChange={handleChange}
                                style={styles.input}
                            />
                        </>
                    )}

                    {/* Use Aroma */}
                    <label style={styles.label}>Use Aroma Before?</label>
                    <div style={styles.radioGroup}>
                        <label style={styles.radioLabel}>
                            <input
                                type="radio"
                                name="useAroma"
                                value="Yes"
                                checked={formData.useAroma === "Yes"}
                                onChange={handleChange}
                                style={styles.radioInput}
                            />
                            Yes
                        </label>
                        <label style={styles.radioLabel}>
                            <input
                                type="radio"
                                name="useAroma"
                                value="No"
                                checked={formData.useAroma === "No"}
                                onChange={handleChange}
                                style={styles.radioInput}
                            />
                            No
                        </label>
                    </div>
                    {errors.useAroma && <p style={styles.errorMessage}>{errors.useAroma}</p>}

                    {/* Travel With */}
                    <label style={styles.label}>Travel With</label>
                    <select
                        name="travelWith"
                        value={formData.travelWith}
                        onChange={handleChange}
                        style={{
                            ...styles.input,
                            ...(errors.travelWith ? styles.inputError : {}),
                        }}
                    >
                        <option value="">Select an option</option>
                        <option value="Alone">Alone</option>
                        <option value="Couple">Couple</option>
                        <option value="Family">Family</option>
                        <option value="Friends">Friends</option>
                        <option value="Groups">Groups</option>
                        <option value="Colleague">Colleague</option>
                    </select>
                    {errors.travelWith && <p style={styles.errorMessage}>{errors.travelWith}</p>}

                    {/* Remarks */}
                    <label style={styles.label}>Any additional remarks or requests?</label>
                    <textarea
                        name="remarks"
                        value={formData.remarks}
                        onChange={handleChange}
                        style={styles.textarea}
                        placeholder="Enter your remarks or requests here"
                    />

                    {/* Well-being question */}
                    <label style={styles.label}>
                        To help us optimize your experience, how would you describe your current well-being?
                    </label>
                    <select
                        name="wellBeing"
                        value={formData.wellBeing}
                        onChange={handleChange}
                        style={{
                            ...styles.input,
                            ...(errors.wellBeing ? styles.inputError : {}),
                        }}
                    >
                        <option value="">Select an option</option>
                        <option value="Energetic">😊 Energetic & refreshed</option>
                        <option value="Neutral">😐 Neutral, could use a lift</option>
                        <option value="Fatigued">😴 Fatigued, needing rejuvenation</option>
                        <option value="Stressed">😖 Stressed, seeking calm</option>
                    </select>
                    {errors.wellBeing && <p style={styles.errorMessage}>{errors.wellBeing}</p>}

                    {/* Aromapod strength */}
                    <label style={styles.label}>
                        Your Aromapod Pro can adjust scent strength. On a scale of 1 (subtle) to 5 (intense), what’s your ideal level? 🌸
                    </label>
                    <div style={styles.radioGroup}>
                        {Array.from({ length: 5 }, (_, i) => (
                            <label key={i + 1} style={styles.radioLabel}>
                                <input
                                    type="radio"
                                    name="aromaStrength"
                                    value={i + 1}
                                    checked={formData.aromaStrength === String(i + 1)}
                                    onChange={handleChange}
                                    style={styles.radioInput}
                                />
                                {i + 1}
                            </label>
                        ))}
                    </div>
                    {errors.aromaStrength && <p style={styles.errorMessage}>{errors.aromaStrength}</p>}

                    {/* Safety concerns */}
                    <label style={styles.label}>
                        To ensure your safety and comfort: Are any guests in your room under 6, pregnant, or with respiratory/allergy concerns? 👶
                    </label>
                    <div style={styles.radioGroup}>
                        <label style={styles.radioLabel}>
                            <input
                                type="radio"
                                name="safetyConcerns"
                                value="Yes"
                                checked={formData.safetyConcerns === "Yes"}
                                onChange={handleChange}
                                style={styles.radioInput}
                            />
                            Yes
                        </label>
                        <label style={styles.radioLabel}>
                            <input
                                type="radio"
                                name="safetyConcerns"
                                value="No"
                                checked={formData.safetyConcerns === "No"}
                                onChange={handleChange}
                                style={styles.radioInput}
                            />
                            No
                        </label>
                    </div>
                    {errors.safetyConcerns && <p style={styles.errorMessage}>{errors.safetyConcerns}</p>}

                    {/* Wellness priority */}
                    <label style={styles.label}>
                        What’s your top wellness priority during this stay? 🌟
                    </label>
                    <select
                        name="wellnessPriority"
                        value={formData.wellnessPriority}
                        onChange={handleChange}
                        style={{
                            ...styles.input,
                            ...(errors.wellnessPriority ? styles.inputError : {}),
                        }}
                    >
                        <option value="">Select an option</option>
                        <option value="Sleep">💤 Deep, uninterrupted sleep</option>
                        <option value="Relaxation">🧘 Full-body relaxation</option>
                        <option value="Focus">🎯 Mental clarity & focus</option>
                        <option value="Joy">😊 Mood enhancement & joy</option>
                    </select>
                    {errors.wellnessPriority && <p style={styles.errorMessage}>{errors.wellnessPriority}</p>}

                    {/* Visit reason */}
                    <label style={styles.label}>
                        What brings you here? ✈️
                    </label>
                    <select
                        name="visitReason"
                        value={formData.visitReason}
                        onChange={handleChange}
                        style={{
                            ...styles.input,
                            ...(errors.visitReason ? styles.inputError : {}),
                        }}
                    >
                        <option value="">Select an option</option>
                        <option value="Business">💼 Business (productivity focus)</option>
                        <option value="Romantic">💑 Romantic getaway</option>
                        <option value="Family">👨‍👩‍👧‍👦 Family bonding</option>
                        <option value="Health">🍃 Health retreat</option>
                        <option value="Solo">🧘 Solo recharge</option>
                    </select>
                    {errors.visitReason && <p style={styles.errorMessage}>{errors.visitReason}</p>}

                    <div style={styles.termsContainer}>
                        <input
                            type="checkbox"
                            id="termsCheckbox"
                            checked={isChecked}
                            onChange={(e) => setIsChecked(e.target.checked)}
                            style={styles.termsCheckbox}
                        />
                        <label htmlFor="termsCheckbox" style={styles.termsLabel}>
                            I agree to the{" "}
                            <a
                                href="https://www.katlai.com/app-policy"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={styles.termsLink}
                                onMouseOver={(e) => (e.target.style.color = styles.termsLinkHover.color)}
                                onMouseOut={(e) => (e.target.style.color = styles.termsLink.color)}
                            >
                                terms and conditions
                            </a>
                        </label>
                    </div>

                    <div style={styles.congratsMessage}>
                        <p>
                            <strong>Congratulations! 🎉</strong>
                        </p>
                        <p>
                            You will be upgraded to our exclusive <strong>Premium Wellness Sleep Room!</strong>
                        </p>
                    </div>

                    {/* Submit Button */}
                    <button
                        type="submit"
                        disabled={isSubmitting}
                        style={{
                            ...styles.button,
                            ...(isSubmitting ? styles.buttonDisabled : {}),
                        }}
                    >
                        {isSubmitting ? "Submitting..." : "Submit"}
                    </button>
                </form>
            )}
        </div>
    );
}

// Inline styles
const styles = {
    container: {
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f8f9fa",
        padding: "40px",
        fontFamily: "'Arial', sans-serif",
    },
    card: {
        backgroundColor: "#ffffff",
        borderRadius: "10px",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
        padding: "20px",
        maxWidth: "500px",
        width: "100%",
    },
    heading: {
        fontSize: "24px",
        fontWeight: "bold",
        textAlign: "center",
        color: "#333",
        marginBottom: "20px",
    },
    label: {
        display: "block",
        fontSize: "14px",
        fontWeight: "600",
        color: "#555",
        marginBottom: "10px",
    },
    input: {
        width: "100%",
        padding: "10px",
        marginBottom: "25px",
        border: "1px solid #ccc",
        borderRadius: "5px",
        fontSize: "14px",
        outline: "none",
        boxSizing: "border-box",
    },
    radioGroup: {
        display: "flex",
        marginBottom: "25px",
    },
    radioLabel: {
        marginRight: "15px",
        fontSize: "14px",
        color: "#555",
    },
    radioInput: {
        marginRight: "5px",
    },
    button: {
        width: "100%",
        padding: "10px",
        backgroundColor: "#007bff",
        color: "#fff",
        border: "none",
        borderRadius: "5px",
        fontSize: "16px",
        cursor: "pointer",
        transition: "background-color 0.3s",
    },
    buttonDisabled: {
        backgroundColor: "#ccc",
        cursor: "not-allowed",
    },
    text: {
        fontSize: "16px",
        color: "#555",
        textAlign: "center",
    },

    textarea: {
        width: "100%",
        height: "120px", // 高度可調整
        padding: "12px",
        marginBottom: "25px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        fontSize: "16px",
        outline: "none",
        resize: "none", // 禁止調整大小，根據需求可去掉
        boxSizing: "border-box",
    },
    termsContainer: {
        display: "flex",
        alignItems: "center",
        marginBottom: "20px",
    },

    termsCheckbox: {
        marginRight: "10px",
        width: "16px",
        height: "16px",
        cursor: "pointer",
    },

    termsLabel: {
        fontSize: "14px",
        fontWeight: "600",
        color: "#555",
    },

    termsLink: {
        color: "#007bff",
        textDecoration: "none",
        fontWeight: "600",
        transition: "color 0.3s ease",
    },

    termsLinkHover: {
        color: "#0056b3",
        textDecoration: "underline",
    },
    successPage: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        background: "#fff",
        borderRadius: "8px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        maxWidth: "400px",
        margin: "0 auto",
    },
    //   input: {
    //     width: "100%",
    //     padding: "10px",
    //     margin: "10px 0",
    //     border: "1px solid #ccc",
    //     borderRadius: "4px",
    //   },
    confirmButton: {
        background: "#28a745",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
        padding: "10px 20px",
        cursor: "pointer",
        margin: "10px",
    },
    disabledButton: {
        background: "#ccc", // 灰色背景
        color: "#666", // 灰色文字
        cursor: "not-allowed", // 禁用鼠標樣式
    },
    cancelButton: {
        background: "#6c757d",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
        padding: "10px 20px",
        cursor: "pointer",
        margin: "10px",
    },
    congratsMessage: {
        backgroundColor: "#f9f9f9",
        padding: "20px",
        borderRadius: "8px",
        marginTop: "30px",
        marginBottom: "30px",
        border: "1px solid #ddd",
        textAlign: "center",
        fontSize: "16px",
        color: "#333",
        lineHeight: "1.6",
    },
    errorMessage: {
        color: "red",
        fontSize: "12px",
        marginTop: "-15px",
        marginBottom: "24px",
    },

    // ✅ 通用樣式
    input: {
        width: "100%",
        padding: "10px",
        marginBottom: "25px",
        border: "1px solid #ccc",
        borderRadius: "5px",
        fontSize: "14px",
        outline: "none",
        boxSizing: "border-box",
        transition: "border-color 0.3s ease", // 增加交互效果
    },

    // ✅ 錯誤樣式
    inputError: {
        borderColor: "red", // 統一使用紅色邊框表示錯誤
        backgroundColor: "#ffe6e6", // 添加背景色提示
    },

    // ✅ 提取按鈕樣式
    button: {
        width: "100%",
        padding: "10px",
        backgroundColor: "#007bff",
        color: "#fff",
        border: "none",
        borderRadius: "5px",
        fontSize: "16px",
        cursor: "pointer",
        transition: "background-color 0.3s ease",
    },

    buttonDisabled: {
        backgroundColor: "#ccc",
        cursor: "not-allowed",
    },

    loadingSpinner: {
        width: "50px",
        height: "50px",
        border: "6px solid #f3f3f3",
        borderTop: "6px solid #007bff",
        borderRadius: "50%",
        animation: "spin 1s linear infinite",
        margin: "0 auto",
    },
    "@keyframes spin": {
        from: { transform: "rotate(0deg)" },
        to: { transform: "rotate(360deg)" },
    },
    select: {
        width: "80px",
        height: "40px",
        fontSize: "16px",
        textAlign: "center",
        border: "1px solid #ccc",
        borderRadius: "5px",
        backgroundColor: "#fff",
        cursor: "pointer",
    },

};

export default WellnessCheckInForm;